import { FC } from 'react';
import { Select } from 'antd';
import { FiTriangle } from 'react-icons/fi';
import type { SelectProps } from 'antd/lib/select';
import styles from './index.module.scss';

interface IProps extends SelectProps {
  hasFilter?: boolean;
}
const SelectCore: FC<IProps> = ({ hasFilter, ...props }) => {
  const isIncludeValue = (value: string, input: string): boolean => {
    return value.toLowerCase().includes(input.toLowerCase());
  };
  return (
    <Select
      {...props}
      removeIcon
      suffixIcon={<FiTriangle size={18} className={styles['icon']} />}
      className={styles['select']}
      showSearch={hasFilter}
      filterOption={(input, option) =>
        isIncludeValue(String(option?.label), input)
      }
    />
  );
};

export default SelectCore;
